export enum OperationType {
  Create = 'Create',
  Update = 'Update',
  Delete = 'Delete',
  Admit = 'Admit',
  Sync = 'Sync',
}

export enum SyncStatus {
  Pending = 'Pending',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
  DeadLettered = 'DeadLettered',
}

export const operationTypeMap: Record<OperationType, string> = {
  [OperationType.Create]: 'Create',
  [OperationType.Update]: 'Update',
  [OperationType.Delete]: 'Delete',
  [OperationType.Admit]: 'Admit',
  [OperationType.Sync]: 'Sync',
};

export const syncStatusMap: Record<SyncStatus, string> = {
  [SyncStatus.Pending]: 'Pending',
  [SyncStatus.Succeeded]: 'Succeeded',
  [SyncStatus.Failed]: 'Failed',
  [SyncStatus.DeadLettered]: 'Dead Lettered',
};

export const operationTypeOptions = [
  { value: OperationType.Create, label: operationTypeMap[OperationType.Create] },
  { value: OperationType.Update, label: operationTypeMap[OperationType.Update] },
  { value: OperationType.Delete, label: operationTypeMap[OperationType.Delete] },
  { value: OperationType.Admit, label: operationTypeMap[OperationType.Admit] },
  { value: OperationType.Sync, label: operationTypeMap[OperationType.Sync] },
];

export const syncStatusOptions = [
  { value: SyncStatus.Pending, label: syncStatusMap[SyncStatus.Pending] },
  { value: SyncStatus.Succeeded, label: syncStatusMap[SyncStatus.Succeeded] },
  { value: SyncStatus.Failed, label: syncStatusMap[SyncStatus.Failed] },
  { value: SyncStatus.DeadLettered, label: syncStatusMap[SyncStatus.DeadLettered] },
];
